import type { SVGProps } from 'react';
const target = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.75 3.0332C17.1222 3.394 20.605 6.87785 20.9658 11.25H22.5V12.75H20.9658C20.605 17.1221 17.1221 20.605 12.75 20.9658V22.5H11.25V20.9658C6.87787 20.605 3.39501 17.1221 3.03418 12.75H1.5V11.25H3.03418C3.39501 6.87785 6.87784 3.394 11.25 3.0332V1.5H12.75V3.0332ZM12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5Z"
      fill={props.color ?? '#144761'}
    />
  </svg>
);
export default target;
